import Flickity from 'flickity'
import 'flickity-imagesloaded'
import isNull from 'lodash/isNull'

export default class ProductSuggestion {
    constructor() {
        this.cacheDom()
        this.initialize()
        this.bindEvents()
    }

    cacheDom() {
        this.desktop = window.matchMedia('(min-width: 1024px)').matches
        this.flkty = null
        this.carousel = document.querySelector('.featured-products-carousel')
        this.carouselActive = document.getElementById('featured-products-active')
        this.carouselTotal = document.getElementById('featured-products-total')
        this.nextArrow = document.querySelector('.featured-products-arrows.next')
        this.prevArrow = document.querySelector('.featured-products-arrows.prev')
    }

    initialize() {
        if (!isNull(this.carousel)) {
            this.flkty = new Flickity(this.carousel, {
                cellAlign: 'left',
                prevNextButtons: false,
                pageDots: false,
                wrapAround: true,
                imagesLoaded: true,
                on: {
                    ready: this.handleCarouselInit()
                }
            })

            this.flkty.on('change', this.handleCarouselChange.bind(this))
        }
    }

    bindEvents() {
        if (!isNull(this.nextArrow)) {
            this.nextArrow.addEventListener('click', () => {
                this.flkty.next(true, false)
            })

            this.prevArrow.addEventListener('click', () => {
                this.flkty.previous(true, false)
            })
        }
    }

    handleCarouselInit() {
        if (!this.desktop || isNull(this.carouselTotal)) {
            return
        }

        const total = parseInt(this.carouselTotal.innerHTML)

        if (!isNaN(total) && total <= 3) {
            this.carouselActive.innerHTML = total
            this.nextArrow.remove()
            this.prevArrow.remove()
        }
    }

    handleCarouselChange(index) {
        index++
        this.carouselActive.innerHTML = index
    }
}
